//t = current time
//b = start value
//c = change in value
//d = duration
Math.easeInOutQuad = function (t, b, c, d) {
  t /= d / 2
  if (t < 1) { return c / 2 * t * t + b }
  t--
  return -c / 2 * (t * (t - 2) - 1) + b
}

export default {
  data() {
    return {
      savedRange: null,
    }
  },
  methods: {
    $_restoreSelection(nameRef) {
      this.focused = true
      const editor = document.getElementById(nameRef)
      editor.focus()
      if (this.savedRange != null) {
        if (window.getSelection) {
          //non IE and there is already a selection
          var s = window.getSelection()
          if (s.rangeCount > 0) { s.removeAllRanges() }
          s.addRange(this.savedRange)
        } else if (document.createRange) {
          //non IE and no selection
          window.getSelection().addRange(this.savedRange)
        } else if (document.selection) {
          //IE
          this.savedRange.select()
        }
      }
    },
    $_saveSelection() {
      if (window.getSelection) {
        //non IE Browsers
        this.savedRange = window.getSelection().getRangeAt(0)
      } else if (document.selection) {
        //IE
        this.savedRange = document.selection.createRange()
      }
    },
    $_cancelEvent(e) {
      if (this.focused == false && this.savedRange != null) {
        if (e && e.preventDefault) {
          e.stopPropagation()
          e.preventDefault()
        } else {
          window.event.cancelBubble = true
        }
        this.$_restoreSelection('editor')
        return false
      }
    },
    /**
     * Плавный скрол внутри еллемента
     * @param {*} element Кого скроллим
     * @param {*} to размер прокрутки
     * @param {*} duration плавность
     */
    $_scrollTo(element, to, duration) {
      if (!element) {
        element = document.body
      }
      var start = element.scrollTop,
        change = to - start,
        currentTime = 0,
        increment = 20

      var animateScroll = function() {
        currentTime += increment
        var val = Math.easeInOutQuad(currentTime, start, change, duration)
        element.scrollTop = val
        if (currentTime < duration) {
          setTimeout(animateScroll, increment)
        }
      }
      animateScroll()
    },
    $_isScrolledIntoView(el) {
      var rect = el.getBoundingClientRect()
      var elemTop = rect.top
      var elemBottom = rect.bottom

      var isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight)
      return isVisible
    },
  }
}
